/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Study from './study';
import StudyDetail from './study-detail';
import StudyUpdate from './study-update';
import StudyDeleteDialog from './study-delete-dialog';

const StudyRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Study />} />
    <Route path="new" element={<StudyUpdate />} />
    <Route path=":id">
      <Route index element={<StudyDetail />} />
      <Route path="edit" element={<StudyUpdate />} />
      <Route path="delete" element={<StudyDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default StudyRoutes;
